<nz-row nzGutter="24">
  <nz-col [nzSm]="24">
    <nz-input-number
      [name]="config.name"
      [nzPlaceHolder]="config.placeholder"
      [(ngModel)]="config.value"
      (ngModelChange)="onChange($event)"
      [nzPrecision]="0"
      nzPrecisionMode="cut"
      [nzMin]="config.min"
      [nzMax]="config.max"
      [nzStep]="config.step"
      style="width: 100%"
      [required]="config.required"
    ></nz-input-number>
  </nz-col>
  <nz-col [nzSm]="24" *ngIf="config.ruleType === ruleType.Limit">
    <app-limit-display [config]="config"> </app-limit-display>
  </nz-col>
  <nz-col [nzSm]="24" *ngIf="config.ruleType === ruleType.Effective && config.effective.length">
    <app-effective-display [config]="config"> </app-effective-display>
  </nz-col>
</nz-row>
